import { ProfileScreen } from "~/settings/profile-screen";

// /profile — the user's account profile (V2-E6.3). Currently the phone number
// used for SMS handover-code delivery. Available to every authenticated user;
// rendered inside <AppShell> like the rest of the protected routes.
export default function ProfileRoute(): JSX.Element {
  return <ProfileScreen />;
}
